module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fyji0"))).then(() => parcelRequire('ljYL6'));